import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_plane",
  "use": "icon_plane-usage",
  "viewBox": "0 0 26 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 24\" id=\"icon_plane\"><path d=\"M.444 2.286l3.434 7.917 9.836 1.038c.234.024.41.224.406.46a.455.455 0 01-.42.448l-9.863.736-3.674 7.809c-.3.613-.179 1.352.305 1.835a1.604 1.604 0 001.832.356l21.938-9.663a1.513 1.513 0 00.486-2.416 1.56 1.56 0 00-.445-.317L2.65.158a1.638 1.638 0 00-2.2 2.134l-.005-.006z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol